// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.drag-drop-upload {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 30px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s ease;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
}

.drag-drop-upload:hover {
  border-color: #750033;
  background-color: #370018;
}

.drag-drop-upload.dragging {
  border-color: #750033;
  background-color: #370018;
}

.upload-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  z-index: 1;
}

.upload-icon {
  font-size: 2.5rem;
  color: #750033;
  margin-bottom: 15px;
}

.upload-text h4 {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  text-align: center;
}

.upload-text p {
  margin: 8px 0;
  color: #666;
  text-align: center;
}

.upload-text small {
  color: #999;
  display: block;
  margin-top: 10px;
  text-align: center;
}

.drop-zone-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #750033;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 2;
  animation: pulse 2s infinite ease-in-out;
  transition: opacity 0.3s ease;
}

.drop-icon {
  font-size: 3rem;
  color: white;
  margin-bottom: 15px;
}

.drop-zone-overlay p {
  color: white;
  font-weight: 600;
  font-size: 1.2rem;
}

@keyframes pulse {
  0% {
    filter: brightness(90%);
  }
  50% {
    filter: brightness(120%);
  }
  100% {
    filter: brightness(90%);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/DragDropImageUpload.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,wCAAwC;EACxC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".drag-drop-upload {\n  border: 2px dashed #ccc;\n  border-radius: 8px;\n  padding: 30px;\n  cursor: pointer;\n  position: relative;\n  transition: all 0.3s ease;\n  min-height: 200px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  width: 100%;\n}\n\n.drag-drop-upload:hover {\n  border-color: #750033;\n  background-color: #370018;\n}\n\n.drag-drop-upload.dragging {\n  border-color: #750033;\n  background-color: #370018;\n}\n\n.upload-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  z-index: 1;\n}\n\n.upload-icon {\n  font-size: 2.5rem;\n  color: #750033;\n  margin-bottom: 15px;\n}\n\n.upload-text h4 {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  text-align: center;\n}\n\n.upload-text p {\n  margin: 8px 0;\n  color: #666;\n  text-align: center;\n}\n\n.upload-text small {\n  color: #999;\n  display: block;\n  margin-top: 10px;\n  text-align: center;\n}\n\n.drop-zone-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #750033;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  z-index: 2;\n  animation: pulse 2s infinite ease-in-out;\n  transition: opacity 0.3s ease;\n}\n\n.drop-icon {\n  font-size: 3rem;\n  color: white;\n  margin-bottom: 15px;\n}\n\n.drop-zone-overlay p {\n  color: white;\n  font-weight: 600;\n  font-size: 1.2rem;\n}\n\n@keyframes pulse {\n  0% {\n    filter: brightness(90%);\n  }\n  50% {\n    filter: brightness(120%);\n  }\n  100% {\n    filter: brightness(90%);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
